import GeometryBase from "./geo-base";

class GeometryOrthohedron extends GeometryBase {
    constructor(canvasSize) {

        GeometryOrthohedron.pairs = GeometryOrthohedron.pairs || [
            [
                new THREE.Line3(new THREE.Vector3(0.0, 0.0), new THREE.Vector3(0.0, 1.0)),
                new THREE.Line3(new THREE.Vector3(1.0, 0.0), new THREE.Vector3(1.0, 1.0))
            ]
        ];

        GeometryOrthohedron.indices = GeometryOrthohedron.indices || [
            [[3, 1, 2], [1, 0, 2]],     // 0
            [[6, 4, 7], [4, 5, 7]],     // 1

            [[1, 3, 5], [3, 7, 5]],     // 2
            [[2, 0, 6], [0, 4, 6]],     // 3

            [[0, 1, 4], [1, 5, 4]],     // 4
            [[3, 2, 7], [2, 6, 7]]      // 5
        ];

        GeometryOrthohedron.additionalPairs = GeometryOrthohedron.additionalPairs || [
            new THREE.Line3(new THREE.Vector3(0, 0), new THREE.Vector3(1, 0)),
            new THREE.Line3(new THREE.Vector3(0, 1), new THREE.Vector3(1, 1))
        ];

        GeometryOrthohedron.vertices = GeometryOrthohedron.vertices || new Array(
            new THREE.Vector3(-0.5, -0.5, -0.5),
            new THREE.Vector3(-0.5, -0.5, +0.5),
            new THREE.Vector3(+0.5, -0.5, -0.5),
            new THREE.Vector3(+0.5, -0.5, +0.5),

            new THREE.Vector3(-0.5, +0.5, -0.5),
            new THREE.Vector3(-0.5, +0.5, +0.5),
            new THREE.Vector3(+0.5, +0.5, -0.5),
            new THREE.Vector3(+0.5, +0.5, +0.5)
        );

        GeometryOrthohedron.attrIndices = GeometryOrthohedron.attrIndices || new THREE.Uint8BufferAttribute([0, 1, 2, 3, 4, 5], 1);
        GeometryOrthohedron.attrUv = GeometryOrthohedron.attrUv || new THREE.Float32BufferAttribute([
            0.0, 0.0,
            1.0, 0.0,
            0.0, 1.0,

            1.0, 0.0,
            1.0, 1.0,
            0.0, 1.0,
        ], 2);

        super(canvasSize);
    }
}

export default GeometryOrthohedron;
export { GeometryOrthohedron };

